export interface IMatchOffer {
    donorAlias: string,
    donorCenter: string,
    recipientAlias: string,
    recipientCenter: string
}